import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import SchreibenSieUns from "./sections/SchreibenSieUns";
import MyLocation from "./sections/MyLocation";
import FaqHilfeCenter from "./sections/FaqHilfeCenter";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <SchreibenSieUns />
      <MyLocation />
      <FaqHilfeCenter />
      <Footer />
    </div>;
}